module.exports = __webpack_public_path__ + "static/media/raffles.5f463943.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/raffles.png
// module id = 1224
// module chunks = 0